module.exports = __webpack_public_path__ + "static/devices-83145636e6290565f5ef33c903320a5a.png";